import { useNavigate } from 'react-router-dom'

function Login() {
  const navigate = useNavigate()

  function handleLogin() {
    localStorage.setItem('techdelivery_token', 'temporary-token')
    navigate('/comenzi')
  }

  return (
    <div className="loginPage">
      <div className="loginBox">
        <h1>Login</h1>
        <button onClick={handleLogin}>Intră în admin</button>
      </div>
    </div>
  )
}

export default Login